import React, { useEffect } from "react";
//import TituloCard from "../../atoms/titles/Titulo";
import "./cardNoResumen.scss";
//import ButtonCardMini from "../../atoms/buttons/ButtonCardMini";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../resources/img/icono-normativas.png";

const ConcursoTrasladoNoResumen = () => {
  useEffect(() => { }, []);
  const navigate = useNavigate();
  return (
    <section className="temas">
      <Link to="/concursos"
      title="Concursos de traslado"
      aria-label="Concursos de traslado"
      role="link"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          navigate("/concursos")
        }
      }}
      >
        <div className="card-caja-mini temas card m-4 h-auto">

          <div className="tituloAccesibilidad d-flex align-items-center">
            <img

              alt="Concursos de traslado"
              src={Logo}
            />
            <h3 className="tituloAccesibilidad ms-2">Concursos de traslado</h3>
          </div>

          <span className="mx-4 fw-light">
            Últimos Concursos de Traslado disponibles para consultar.
          </span>
          {/*<p style={{ marginTop: "auto", textAlign: "right" }}>
        <Link to="/concursos">
          <ButtonCardMini nombre="Acceder" clases="btn-card" />
  </Link>
  </p>*/}

        </div>
      </Link>
    </section>
  );
};
export default ConcursoTrasladoNoResumen;
